var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46533 13.9891L4.03721 8.56099L5.24658 7.35161L8.62158 10.7266V0.292236H10.3091V10.7266L13.6841 7.35161L14.8935 8.56099L9.46533 13.9891ZM2.15283 18.2922C1.70283 18.2922 1.30908 18.1235 0.971582 17.786C0.634082 17.4485 0.465332 17.0547 0.465332 16.6047V12.5829H2.15283V16.6047H16.7778V12.5829H18.4653V16.6047C18.4653 17.0547 18.2966 17.4485 17.9591 17.786C17.6216 18.1235 17.2278 18.2922 16.7778 18.2922H2.15283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/icon-download-white.cbfbf52f5c736aeac8128820743fb5a5.svg";
export { ForwardRef as ReactComponent };